<template>
  <div
    v-if="loading > 0"
    class="loading-indicator"
  >
    <span>Working on it&hellip;</span>
  </div>
</template>

<script>
export default {
  name: 'LoadingIndicator',
  props: {
    loading: {
      type: Number,
      required: true,
    },
  },
};
</script>
